import React, { useLayoutEffect, useState, Fragment, useEffect } from 'react';
import { withNamespaces } from 'react-i18next';
import { withSitecoreContext, Text } from '@sitecore-jss/sitecore-jss-react';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Box from '../../../components/molecules/Box';
import Grid from '../../../components/molecules/Grid';
import { Hidden, NoSsr } from '@material-ui/core';
import Typography from '../../../components/atoms/Typography';
import Button from '../../../components/atoms/Button';
import { COMPONENT_NAME } from './locators';
import fetchService from '../../../../services/FetchService';
import Picture from '../../../components/atoms/Picture';
import useMediaQuery from '@material-ui/core/useMediaQuery';
// import { useTheme } from '@material-ui/core/styles';
import { breakpoints } from '../../../../styles/themes/vad/constants';
import Overlay from '../../../components/atoms/Overlay';
import Tooltip from '../../../components/atoms/Tooltip';
import HeroCarousel from '../../../components/organism/HeroCarousel';
import { analyticsData } from '../../../../constants/Analytics/analytics-data';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../utils/analytics';
import DctSvgIcon from '../../../components/atoms/Svg';
import { canUseDOM } from '../../../utils/canUseDOM';
import { debounce, get } from 'lodash';
import {
  evalConditionForInsideChina,
  isInsideChina,
  isLanguageEqual,
  isDomainCN,
} from '../../../utils/cookie';
import { LANGUAGE_CODE, DOMAIN_SUFFIX } from '../../../../constants';
import checkForPropsValue from '../../../utils/checkForPropsValue';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import useStyles from './style';
import Link from '../../../components/atoms/Link';
import Avatar from '../../../components/atoms/Avatar';

const getSocialShareIcon = (social_id, url) => {
  let socialPlatform = social_id.includes('_')
    ? social_id.split('_')[0].toLowerCase()
    : social_id.toLowerCase();

  if (socialPlatform === 'custom') {
    const urlObj = new URL(url);
    socialPlatform = urlObj.host.split('.')[1];
  }

  const tintSourceList = [
    'facebook',
    'twitter',
    'instagram',
    'youtube',
    'vine',
    'googleplus',
    'tumblr',
    'flickr',
    'google_news',
    'rss',
    'pinterest',
    'linkedin',
    'custom',
    'wechat',
    'weibo',
    'hootsuite',
    'slack',
  ];

  if (tintSourceList.includes(`${socialPlatform}`)) {
    return <DctSvgIcon name={`${socialPlatform}Icon`} />;
  } else {
    return <DctSvgIcon name="InstagramIcon" />;
  }
};

const OverlayCard = props => {
  const classes = useStyles();
  const {
    language,
    socialList,
    userName,
    userHandle,
    profileLink,
    userPic,
    image,
    description,
    //timestamp,
    social_id,
    url,
    title,
    emailSubject,
  } = props.fields || {};
  // const postAge = moment(
  //   moment.unix(timestamp).format('YYYYMMDD'),
  //   'YYYYMMDD'
  // ).fromNow();

  const generateSocialList = (url, title, image, emailSubject) => {
    return (
      <ul className={classes.shareMenuList}>
        <li className={classes.shareMenuListItem}>
          <a
            className={classes.shareMenuItemLink}
            href={`https://twitter.com/intent/tweet?url=${url}&text=${title}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DctSvgIcon name="twittericoncolored" />
            <Typography component="span" variant="body2">
              {socialList && socialList.length > 0 && socialList[4]}
            </Typography>
          </a>
        </li>
        <li className={classes.shareMenuListItem}>
          <a
            className={classes.shareMenuItemLink}
            href={`http://www.facebook.com/sharer.php?u=${url}&t=${title}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DctSvgIcon name="facebookiconcolored" />
            <Typography component="span" variant="body2">
              {socialList && socialList.length > 0 && socialList[3]}
            </Typography>
          </a>
        </li>
        <li className={classes.shareMenuListItem}>
          <a
            className={classes.shareMenuItemLink}
            href={`https://www.linkedin.com/shareArticle?url=${url}&title=${title}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DctSvgIcon name="linkediniconcolored" />
            <Typography component="span" variant="body2">
              {socialList && socialList.length > 0 && socialList[2]}
            </Typography>
          </a>
        </li>
        <li className={classes.shareMenuListItem}>
          <a
            className={classes.shareMenuItemLink}
            href={`https://www.pinterest.com/pin/create/button/?url=${url}&description=${title}&media=${image}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DctSvgIcon name="pinteresticoncolored" />
            <Typography component="span" variant="body2">
              {socialList && socialList.length > 0 && socialList[1]}
            </Typography>
          </a>
        </li>
        <li className={classes.shareMenuListItem}>
          <a
            className={classes.shareMenuItemLink}
            href={`mailto:?subject=${emailSubject ||
              ''}&body=${description} %0D%0A ${url}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <DctSvgIcon name="mailiconcolored" />
            <Typography component="span" variant="body2">
              {socialList && socialList.length > 0 && socialList[0]}
            </Typography>
          </a>
        </li>
      </ul>
    );
  };

  return (
    <Grid container className={classes.overlayCard}>
      <Grid item xs={12} lg={6} className={classes.overlayCardPicture}>
        <Picture
          isParalax={false}
          media={{ renditionNeeded: false, image: image }}
          alternateAltText={title && title.value}
        />
      </Grid>
      <Grid
        container
        spacing={0}
        item
        xs={12}
        lg={6}
        className={classes.overlayCardDescription}
      >
        <Grid item xs={12}>
          <Grid item xs={12} container spacing={0} alignItems="center">
            <Grid container alignItems="center" item xs={10}>
              <Link
                customHref={profileLink}
                isCustom={true}
                className={''}
                target="_blank"
              >
                <Avatar className="icon">
                  <Picture
                    isParalax={false}
                    media={{
                      image: userPic,
                      renditionNeeded: false,
                      disableLazyLoad: true,
                    }}
                    alternateAltText={title && title.value}
                  />
                </Avatar>
              </Link>
              <Link
                customHref={profileLink}
                isCustom={true}
                className={classes.titleWrap}
                target="_blank"
              >
                <Typography variant="h5" component="p">
                  {userName ? userName : userHandle}
                </Typography>
                <Typography variant="body2" component="p" className="text-gray">
                  {userHandle && `@${userHandle}`}
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={2}>
              <Link customHref={url} isCustom={true} target="_blank">
                <Avatar className="icon">
                  {social_id && getSocialShareIcon(social_id, url)}
                </Avatar>
              </Link>
            </Grid>
          </Grid>
          <Grid item xs={12} className="description">
            <Typography variant="body1" component="p">
              {description &&
                description.split('#').map((word, index) => {
                  return (
                    <Fragment key={word + index}>
                      {(description.indexOf('#') === 0 || index > 0) && (
                        <span className="redColorText">
                          {word &&
                            `#${word.substring(
                              0,
                              word.indexOf(' ') === -1
                                ? word.length
                                : word.indexOf(' ')
                            )} `}
                        </span>
                      )}
                      {word &&
                        word.indexOf(' ') !== -1 &&
                        word.substring(index === 0 ? 0 : word.indexOf(' '))}
                    </Fragment>
                  );
                })}
            </Typography>
          </Grid>
        </Grid>
        <NoSsr>
          {!isInsideChina({ language }) && !isDomainCN() && (
            <Grid
              container
              item
              xs={12}
              className={`time-and-share ${classes.socialShareWrap}`}
            >
              <Tooltip
                titleNode={generateSocialList(url, title, image, emailSubject)}
                className="tooltipWrap"
              >
                <div className={classes.shareIcon}>
                  <DctSvgIcon name="shareicon" aria-label="social share" />
                </div>
              </Tooltip>
            </Grid>
          )}
        </NoSsr>
      </Grid>
    </Grid>
  );
};

const Tint = props => {
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const [tintData, setTintData] = useState([]);
  const [isOverlayVisible, setVisibleState] = useState(false);
  const [currentSlidePos, setCurrentSlidePos] = useState(1);
  const [cellHeight, setCellHeight] = useState('auto');
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(`(max-width:${breakpoints.values.md}px)`);

  const { title, viewAllLink, itemCount, tintFeedName } = props.fields;
  const { appConfig = {}, sitecoreContext } = props;
  const dictionary = props && props.t;
  const socialShareList = dictionary && [
    dictionary('socialShare_Email'),
    dictionary('socialShare_Pinterest'),
    dictionary('socialShare_LinkedIn'),
    dictionary('socialShare_Facebook'),
    dictionary('socialShare_Twitter'),
  ];

  let tags = checkForPropsValue(
    get(props, 'fields.ugcTags'),
    get(props, 'sitecoreContext.route.fields.ugcTags')
  );

  // Email subject using (page title OR name AND dictionary value)
  let emailSubject =
    (sitecoreContext &&
      get(sitecoreContext, 'route.fields.pageHeading.value', '')) ||
    get(sitecoreContext, 'route.fields.name.value', '');
  const tintEmailSubjectFirstPart =
    dictionary && dictionary('tintEmailSubjectFirstPart');
  const tintEmailSubjectLastPart =
    dictionary && dictionary('tintEmailSubjectLastPart');
  emailSubject = `${tintEmailSubjectFirstPart} ${emailSubject} ${tintEmailSubjectLastPart}`;

  const widthOfTile = () => {
    const id = tintData && tintData.length > 2 ? 'thirdTile' : 'firstTile';
    const width =
      canUseDOM &&
      document.getElementById(id) &&
      document.getElementById(id).clientWidth;
    width && width > 0 && setCellHeight(width - 24);
  };
  useLayoutEffect(() => {
    const widthOfTileWithDebounce = debounce(widthOfTile, 500);
    canUseDOM && window.addEventListener('resize', widthOfTileWithDebounce);
    return () => window.removeEventListener('resize', widthOfTileWithDebounce);
  }, []);

  useEffect(() => {
    tags = checkForPropsValue(
      get(props, 'fields.ugcTags'),
      get(props, 'sitecoreContext.route.fields.ugcTags')
    );
    getData && getData();
  }, [
    get(props, 'fields.ugcTags'),
    get(props, 'sitecoreContext.route.fields.ugcTags'),
  ]);

  const classes = useStyles();
  const language = get(
    props,
    'sitecoreContext.language',
    LANGUAGE_CODE.DEFAULT
  );
  if (evalConditionForInsideChina(language)) {
    return null;
  }

  const domainName = canUseDOM && window.location.hostname;
  const domainSuffix =
    domainName && domainName.substr(domainName.lastIndexOf('.'));

  const spaceBtwTiles = 24;
  const buttonIcon = <DctSvgIcon name={'ImageOutlinedIcon'} />;
  // we have to create this cta because we only get see all value as a string
  const cta = {
    value: {
      text:
        (viewAllLink && viewAllLink.value && viewAllLink.value.text) ||
        props.t('seeAll'),
      anchor: '',
      linktype: 'internal',
    },
  };

  if (!(tintFeedName && tintFeedName.value && tags && tags.value)) {
    return null;
  }
  const getData = () => {
    if (
      domainSuffix === DOMAIN_SUFFIX.CHINA ||
      isLanguageEqual(language, LANGUAGE_CODE.CHINESE)
    ) {
      tags = {
        value: `cn-${tags && tags.value}`,
      };
    }

    try {
      fetchService({
        url: `${appConfig.TINT_API}${tintFeedName.value}?count=${itemCount.value
          }${tags && tags.value ? '&tags=' + tags.value : ''}`,
        method: 'GET',
      }).then(res => {
        if (res && res.data && res.data.data) {
          const items = [];
          res.data.data.forEach(item => {
            const userName = JSON.parse(item.author || '{}').name;
            const userHandle = JSON.parse(item.author || '{}').username;
            const userPic = JSON.parse(item.author || '{}').picture;
            const profileLink = JSON.parse(item.author || '{}').link;
            items.push({
              fields: {
                emailSubject: emailSubject,
                language,
                socialList: socialShareList,
                id: item.social_post_id,
                description: item.title,
                userName,
                userHandle,
                userPic: {
                  value: {
                    src: userPic,
                  },
                },
                profileLink,
                timestamp: item.original_timestamp,
                social_id: item.social_id,
                image: {
                  value: {
                    src: item.original_image,
                    alt: '',
                  },
                },
                thumbnailImage: {
                  value: {
                    src: item.original_image,
                    alt: '',
                  },
                },
                url: item.url,
                title: item.title,
                description: item.description,
              },
            });
          });
          setTintData([...items]);
          widthOfTile();
        }
      });
    } catch (error) {
      console.error('Something went wrong with tint api.', error);
    }
  };

  const isShowViewAllBtn = () => {
    const length = tintData.length;
    const firstCase = length > 3 && length < 6;
    const secondCase = length > 6 && length < 9;
    const thirdCase = length > 9;
    return firstCase || secondCase || thirdCase;
  };

  const isFirstCol4Tiles = () => {
    const length = tintData.length;
    return length >= 6;
  };

  const isSecondCol4Tiles = () => {
    const length = tintData.length;
    return length >= 9;
  };
  const thirdTileImageStartNo = () => {
    const length = tintData.length;
    return length < 6 ? 2 : length < 9 ? 5 : 8;
  };

  const setOverlayOpen = (event, isImageClicked) => {
    const slideNo =
      (event && event.target && event.target.getAttribute('data-sequence')) ||
      0;
    setCurrentSlidePos(parseInt(slideNo) + 1);
    setVisibleState(true);
    addAnalyticsInfo(isImageClicked);
  };

  const setIsVisible = isVisible => {
    setVisibleState(isVisible);
    if (!isVisible) {
      // resetting slide count to 1 after closing
      // the overlay
      setCurrentSlidePos(1);
    }
  };

  const getCurrentSlidePos = pos => {
    setCurrentSlidePos(pos);
  };

  const addAnalyticsInfo = isImageClicked => {
    let obj = {};
    if (isImageClicked) {
      obj = {
        ...analyticsData.pageBodyInteraction.tileClick,
      };
    } else {
      obj = {
        ...analyticsData.pageBodyInteraction.seeAllPhotosBtnClick,
      };
    }
    obj.label = createDynamicLabels([
      pageName,
      componentName,
      title && title.value,
    ]);
    pushAnaylyticsData(obj);
  };

  const titleNode = (
    <Fragment>
      <span>
        <Text field={title} />
      </span>
      <Typography variant="body2" component="label" className="slideCount">
        {currentSlidePos}
        {<span>&nbsp; / &nbsp;</span>}
        {tintData.length}
      </Typography>
    </Fragment>
  );
  const imageProps = imageNumber => {
    return {
      sequence: imageNumber,
      onClick: e => setOverlayOpen(e, true),
    };
  };

  if (tintData && tintData.length === 0) {
    return null;
  } else {
    return (
      <Box className={classes.root} data-locator={COMPONENT_NAME}>
        <Grid container>
          {title && (
            <Grid item xs={12} className={classes.title}>
              <Typography variant={'h4'} component={'h2'}>
                <Text field={title} />
              </Typography>
            </Grid>
          )}
          <Grid item xs={12} className={classes.imageContent}>
            {tintData && tintData.length > 0 && (
              <GridList
                cols={isMobile ? 1.3 : 3}
                cellHeight={cellHeight}
                className={classes.gridList}
                spacing={spaceBtwTiles}
              >
                <GridListTile id="firstTile">
                  {isFirstCol4Tiles() ? (
                    <>
                      <GridList
                        cellHeight={cellHeight / 2}
                        spacing={spaceBtwTiles}
                        className={classes.firstRowAdjustment}
                      >
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[0].fields.image,
                            }}
                            {...imageProps(0)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[1].fields.image,
                            }}
                            {...imageProps(1)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                      </GridList>
                      <GridList
                        cellHeight={cellHeight / 2}
                        spacing={spaceBtwTiles}
                        className={classes.secondRowTopMargin}
                      >
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[2].fields.image,
                            }}
                            {...imageProps(2)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[3].fields.image,
                            }}
                            {...imageProps(3)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                      </GridList>
                    </>
                  ) : (
                    <Grid item className={classes.ugcWrapper}>
                      <Picture
                        isParalax={false}
                        media={{
                          renditionNeeded: false,
                          image: tintData[0].fields.image,
                        }}
                        {...imageProps(0)}
                        alternateAltText={title && title.value}
                      />
                      <Avatar className={classes.ugcLogo}>
                        {tintData[0].fields.social_id &&
                          getSocialShareIcon(
                            tintData[0].fields.social_id,
                            tintData[0].fields.url
                          )}
                      </Avatar>
                    </Grid>
                  )}
                </GridListTile>
                <GridListTile>
                  {isSecondCol4Tiles() ? (
                    <>
                      <GridList
                        cellHeight={cellHeight / 2}
                        spacing={spaceBtwTiles}
                        className={classes.firstRowAdjustment}
                      >
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[4].fields.image,
                            }}
                            {...imageProps(4)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[5].fields.image,
                            }}
                            {...imageProps(5)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                      </GridList>
                      <GridList
                        cellHeight={cellHeight / 2}
                        spacing={spaceBtwTiles}
                        className={classes.secondRowTopMargin}
                      >
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[6].fields.image,
                            }}
                            {...imageProps(6)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                        <GridListTile>
                          <Picture
                            isParalax={false}
                            media={{
                              renditionNeeded: false,
                              image: tintData[7].fields.image,
                            }}
                            {...imageProps(7)}
                            alternateAltText={title && title.value}
                          />
                          <Avatar className={classes.ugcLogo}>
                            {tintData[0].fields.social_id &&
                              getSocialShareIcon(
                                tintData[0].fields.social_id,
                                tintData[0].fields.url
                              )}
                          </Avatar>
                        </GridListTile>
                      </GridList>
                    </>
                  ) : (
                    tintData.length > 1 && (
                      <Grid item className={classes.ugcWrapper}>
                        <Picture
                          isParalax={false}
                          media={{
                            renditionNeeded: false,
                            image:
                              tintData[isFirstCol4Tiles() ? 4 : 1].fields.image,
                          }}
                          {...imageProps(isFirstCol4Tiles() ? 4 : 1)}
                          alternateAltText={title && title.value}
                        />
                        <Avatar className={classes.ugcLogo}>
                          {tintData[isFirstCol4Tiles() ? 4 : 1].fields
                            .social_id &&
                            getSocialShareIcon(
                              tintData[isFirstCol4Tiles() ? 4 : 1].fields
                                .social_id,
                              tintData[isFirstCol4Tiles() ? 4 : 1].fields.url
                            )}
                        </Avatar>
                      </Grid>
                    )
                  )}
                </GridListTile>
                <GridListTile id="thirdTile">
                  {tintData.length > 2 && (
                    <Grid item className={classes.ugcWrapper}>
                      <Picture
                        isParalax={false}
                        media={{
                          renditionNeeded: false,
                          image: tintData[thirdTileImageStartNo()].fields.image,
                        }}
                        {...imageProps(thirdTileImageStartNo())}
                        alternateAltText={title && title.value}
                      />
                      <Avatar className={classes.ugcLogo}>
                        {tintData[thirdTileImageStartNo()].fields.social_id &&
                          getSocialShareIcon(
                            tintData[thirdTileImageStartNo()].fields.social_id,
                            tintData[thirdTileImageStartNo()].fields.url
                          )}
                      </Avatar>
                    </Grid>
                  )}
                </GridListTile>
              </GridList>
            )}
          </Grid>
          {isShowViewAllBtn() && (
            <Hidden lgUp implementation="css">
              <Grid item xs={12} className={classes.topMargin}>
                <Button
                  component="span"
                  buttonType="primary"
                  field={{ ...cta }}
                  hasBorder={false}
                  onClick={e => setOverlayOpen(e, false)}
                />
              </Grid>
            </Hidden>
          )}
        </Grid>
        {tintData && tintData.length > 0 && (
          <Overlay
            title={titleNode}
            primaryCTA={cta}
            buttonProps={{
              className: `${classes.seeAllBtn} seeAllBtn`,
              hasBorder: false,
              buttonIcon,
              onClick: e => setOverlayOpen(e, false),
              wrapInner: true,
              animateSettings: {
                willAnimate: false,
              },
            }}
            className={`${classes.overlayWrapper} overlay-wrapper tintOverlay`}
            isVisible={isOverlayVisible}
            setIsVisible={isVisible => setIsVisible(isVisible)}
            withButton={!isMobile && isShowViewAllBtn()}
          >
            <HeroCarousel
              titleText={(title && title.value) || ''}
              carouselItems={tintData}
              isMobile={isMobile}
              thumbnailNeeded={false}
              getCurrentSlidePos={pos => getCurrentSlidePos(pos)}
              CustomComponent={OverlayCard}
              componentName={componentName}
              pageName={pageName}
              carouselConfig={{
                initialSlide: currentSlidePos - 1,
                dots: false,
                fade: true,
                adaptiveHeight: true,
                swipe: false,
                responsive: [
                  {
                    breakpoint: 1023,
                    settings: {
                      fade: false,
                      lazyLoad: false,
                      swipe: true,
                    },
                  },
                ],
              }}
              className={classes.overlayComponentWrapper}
            />
          </Overlay>
        )}
      </Box>
    );
  }
};

export default withErrorBoundary(withSitecoreContext()(withNamespaces()(Tint)));
